import React from "react";
import logo from "../../assets/home/logo utama.webp";
import "./footer.scss";

const footer = () => {
  return (
    <div className="footer">
      <div className="container-atas">
        <div className="image">
          <img src={logo} alt="logo-grandwisata" />
        </div>
        <div className="ket">
          +62895417144022 | Jl. Grand Wisata, Lambangjaya
        </div>
        <div className="plus"></div>
      </div>
      <div className="container-bawah">
        <div className="ket">© 2024 Grand Wisata. All Right Reserved.</div>
      </div>
    </div>
  );
};

export default footer;
